import React from "react"

const SearchCountry = ({handleInput}) => {
    return (
        <input 
            onChange={handleInput}
            placeholder='TYPE COUNTRY NAME'
            className="main-input"/>
    )
}

export default SearchCountry